<template>
  <div>
    <div class="layout-header">
      <div class="infor-layout-header">
        <span class="title">总量设置</span>
      </div>
    </div>
    <div style="height: 6rem"></div>
    <div class="pagination-bg-white layout-header">
      <w-table
        width="100%"
        v-show="checkUserAuth(4, 14)"
        v-loading.body="tableLoading"
        :bPagination="false"
        :data-list="tabledata"
        :columns="columns"
      >
        <template slot-scope="props" slot="cell">
          <span v-if="props.column.label === '操作'">
            <el-button
              v-show="checkUserAuth(4, 12)"
              size="mini"
              @click="onEdit(props.row)"
              >修改</el-button
            >
          </span>
          <span v-else>{{ props.row[props.column.property] }}</span>
        </template>
      </w-table>
    </div>
    <w-dialog
      ref="w-dialog3"
      title="总量设置"
      width="600"
      :sureBtnText="state == 1 ? '确定' : '保存'"
      :isShowFooter="true"
      @handleClose="handleClose3"
      @handleCloseRight="handleClose3"
      @onSure="onSure3"
    >
      <template v-slot:content>
        <el-form
          label-width="5rem"
          ref="formLabelAlignRuleForm"
          :model="formLabelAlign"
          :rules="formLabelAlignRules"
        >
          <el-form-item label="自行车:" prop="bike">
            <el-input
              v-model="formLabelAlign.bike"
              style="width: 80%"
            ></el-input>
            <span
              style="
                margin-left: 0.5rem;
                font-size: 0.75rem;
                color: rgba(0, 0, 0, 0.25);
              "
              >辆</span
            >
          </el-form-item>
          <el-form-item label="电动车:" prop="ebike">
            <el-input
              v-model="formLabelAlign.ebike"
              style="width: 80%"
            ></el-input>
            <span
              style="
                margin-left: 0.5rem;
                font-size: 0.75rem;
                color: rgba(0, 0, 0, 0.25);
              "
              >辆</span
            >
          </el-form-item>
        </el-form>
        <span
          style="margin-left: 1.5rem; font-size: 0.75rem; color: rgba(0, 0, 0, 0.25)"
          >注：该设定只针对运营统计的城市核定投放统计有效</span
        >
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Api from "@/api";
import WDialog from "@/components/Model/index.vue";
import WTable from "@/components/Table/index.vue";

import { mapGetters } from "vuex";
export default {
  components: {
    WDialog,
    WTable,
  },
  data() {
    var bikeNum = (rule, value, callback) => {
      if (String(value).indexOf(".") !== -1) {
        callback(new Error("请输入合法电动车数量"));
      }
      if (value < 0) {
        callback(new Error("请输入合法自行车数量"));
      }
      callback();
    };

    var ebikeNum = (rule, value, callback) => {
      if (String(value).indexOf(".") !== -1) {
        callback(new Error("请输入合法电动车数量"));
      }
      if (value < 0) {
        callback(new Error("请输入合法电动车数量"));
      }
      callback();
    };

    return {
      columns: [
        {
          prop: "bike",
          label: "自行车总量",
        },
        {
          prop: "ebike",
          label: "电动车总量",
        },
        {
          fixed: "right",
          label: "操作",
        },
      ],
      tableLoading: true,
      tabledata: [],
      state: 1, // 1是未设置总量 2是已经设置总量
      formLabelAlign: {},
      formLabelAlignRules: {
        bike: [
          {
            validator: bikeNum,
            message: "请填写合法自行车数量",
            trigger: "blur",
          },
        ],
        ebike: [
          {
            validator: ebikeNum,
            message: "请填写合法电动车数量",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["user", "selfAreaId", "userLevel"]),
  },
  created() {
    if (this.userLevel !== 2) {
      let path = "/CompanyManagement/company/";
      if (this.selfAreaId) {
        path += this.selfAreaId;
      }
      this.$router.push(path);
      return;
    }
    // 先判断有没有设置过
    this.getData();
  },
  methods: {
    getData(isInit = true) {
      this.tableLoading = true;
      Api.getBikeSum(this.selfAreaId).then((res) => {
        this.tableLoading = false;
        if (res.code === 200) {
          if (res.data.id) {
            this.state = 2;
            if (res.data.areaBikeNum + res.data.areaEleBikeNum == 0) {
              this.tabledata = [];
              if (isInit) {
                this.state = 1;
                this.$refs["w-dialog3"].onShowDialog();
              }
            } else {
              console.log(res.data);
              this.tabledata = [
                { bike: res.data.areaBikeNum, ebike: res.data.areaEleBikeNum },
              ];
            }
          } else {
            this.state = 1;
            this.$refs["w-dialog3"].onShowDialog();
          }
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    onEdit() {
      this.state = 2;
      this.formLabelAlign = { ...this.tabledata[0] };
      this.$refs["w-dialog3"].onShowDialog();
    },
    onSure3() {
      this.$refs.formLabelAlignRuleForm.validate((valid) => {
        if (valid) {
          this.handleformLabelAlignFormRole();
        } else {
          return false;
        }
      });
    },
    handleformLabelAlignFormRole() {
      Api.saveBikeSum(
        {
          areaBikeNum: Number(this.formLabelAlign.bike),
          areaEleBikeNum: Number(this.formLabelAlign.ebike),
        },
        this.selfAreaId
      )
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(
              this.state == 1 ? "总量设置成功！" : "总量修改保存成功！"
            );
            this.handleClose3();
          } else {
            this.$message.warning(res.message);
          }
          this.getData(false);
          this.state = 2; // 修改完成
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClose3() {
      this.formLabelAlign = {};
      this.$refs["w-dialog3"].onCloseDialog();
    },
  },
};
</script>

<style lang="less">
.layout-header {
  margin: 16px;
  width: calc(100% - 20px);
}
</style>
